import { Box, Typography } from '@mui/material'
import React from 'react'
import { SummerCampImages } from '../../assets/img/summercamp/SummerCampImages'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import { DotBulletsPoints } from '../../shared/components/StarBulletsPoints'
import { Page_Padding } from '../../shared/constants'
import useResponsive from '../../shared/utils/Responsive'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const WhatWeDoSection = ({ whatWeDoData }) => {
    const points1 = ["Theme-based craft projects", "Hands-on DIY creations", "Drawing,clay modelling"]
    const points3 = ["Storytelling", "Basic etiquette", "Memory games & brain boosters"]
    const points2 = ["Fun movement games", "Dance workshops", "Coordination & motor-skill"]
    const points4 = ["Public speaking basics", "Communication skills", "Confidence-building games"]
    const isMediumScreen = useResponsive("md")
    return (

        <Box>
            <Heading Heading={whatWeDoData?.heading} center />
            <Box sx={{ position: "relative" }}>

                <Box
                    component={"img"}
                    // src={isMediumScreen ? SummerCampImages.WhatWeDoImageWithConent : SummerCampImages.WhatWeDoBgImg}
                    // src={ SummerCampImages.WhatWeDoImageWithConent }
                    src={getImageUrl(whatWeDoData?.imageUrl)}
                    sx={{ width: { xs: "100%", sm: "100%", md: "100%" }, display: "block", mx: "auto", borderRadius: 0 }}

                />

                {/* {
                    !isMediumScreen  && <>
                        <Box sx={{ position: "absolute", top: "50%", left: "5%" }}>
                            <DotBulletsPoints items={points1} dotColor={"#427E8F"} direction='row-reverse' />
                        </Box>
                        <Box sx={{ position: "absolute", top: "0%", right: "10%" }}>
                            <DotBulletsPoints items={points2} dotColor={"#3D3E69"} />
                        </Box>
                        <Box sx={{ position: "absolute", top: "25%", right: "0%" }}>
                            <DotBulletsPoints items={points3} dotColor={"#8861A5"} />
                        </Box>
                        <Box sx={{ position: "absolute", bottom: "0%", left: "15%" }}>
                            <DotBulletsPoints items={points4} dotColor={"#5292BC"} direction='row-reverse' />
                        </Box>

                    </>
                } */}
                <CustomDivider size={"5rem"} />
            </Box>
        </Box>

    )
}

export default WhatWeDoSection
